module.exports = __webpack_public_path__ + "img/coco-club-01.b16cee58.jpg";